import React, { useMemo } from "react";
import { useData, ADMIN_TABLE } from "../../context/DataContext";
import { cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";

export default function OverdueTasksAdmin() {
  const { adminRecords, loading } = useData();

  // Filter to show ALL master tasks that are overdue
  const overdue = useMemo(() =>
    adminRecords.filter((r) => {
      const s = cellText(r.fields?.["Overall Status"]).toLowerCase();
      const isDone = s.includes("done") || s.includes("✅") || s.includes("complet");
      const isOverdue = s.includes("overdue") || s.includes("🔴");
      return isOverdue && !isDone;
    }),
    [adminRecords]
  );

  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading tasks...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>🔴 Overdue Overall Tasks</h1>
        <p>Master tasks that have passed their due date — {overdue.length} records</p>
      </div>
      <TaskTable 
        tableId={ADMIN_TABLE} 
        records={overdue} 
        emptyMsg="No overdue tasks found. Excellent! 🚀"
        canEdit={true}
        canDelete={true}
        hideStatusFilter={true}
      />
    </div>
  );
}
